<template>
    <div class="main">
        <keep-alive>
            <Header></Header>
        </keep-alive>
        <keep-alive>
            <Title v-if="$route.path != '/'"></Title>
        </keep-alive>
        <AppMain></AppMain>
        <Footer></Footer>
    </div>
</template>
<script>
import Header from '../components/header/header.vue'
import Footer from '../components/footer/footer.vue'
import AppMain from './components/AppMain.vue'
import Title from '../components/header/title.vue'

export default ({
    name: 'Layout',
    components: {
        Header,
        Footer,
        AppMain,
        Title
    },
    data() {
        return {
            navIndex: ''
        }
    },
})
</script>
<style lang="scss" scoped>
.main {
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue